// extracted by mini-css-extract-plugin
export default {"root":"Timer_root__Ro-Ky","text":"Timer_text__uL2BE","time":"Timer_time__kwvx-","subText":"Timer_subText__3CUMK","dividerTime":"Timer_dividerTime__PR1qr"};